(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["background-fx"] && !Shopify.designMode) return;
  try {
    (function () {
    var canvas = document.getElementById('zd-bg-canvas');
    if (!canvas) return;
    var shimmer = document.querySelector('.zd-water-shimmer');

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var motion = !reduced;
    var w = 0;
    var h = 0;
    var grid = null;
    var zAt = function () {
      return 0;
    };
    var nodes = [];
    var edges = [];
    var pulses = [];
    var lastSpawn = 0;
    var arrivals = 0;
    var tx = 0;
    var ty = 0;
    var cx = 0;
    var cy = 0;
    var ripples = [];
    var lastMoveRipple = 0;
    var raf = 0;
    var idleTimer = 0;
    var interactive = false;
    var last = performance.now();
    var IDLE_TIMEOUT_MS = 4000;
    var TWINKLE_COLORS = ['150,210,255', '255,196,140', '160,255,210', '255,150,210'];

    function buildNetwork() {
      var P = 26;
      var cols = Math.ceil(w / P) + 2;
      var rows = Math.ceil(h / P) + 2;
      grid = { P: P, cols: cols, rows: rows };
      zAt = function (i, j) {
        return Math.abs(Math.sin(i * 127.1 + j * 311.7) * 43758.5453) % 1;
      };
      nodes = [];
      for (var i = 0; i < cols; i++) {
        for (var j = 0; j < rows; j++) {
          if (Math.random() < 0.04) {
            nodes.push({ x: i * P, y: j * P, z: zAt(i, j), flash: 0, adj: [] });
          }
        }
      }
      edges = [];
      nodes.forEach(function (n, ni) {
        var near = nodes
          .map(function (m, mi) {
            return { mi: mi, d: Math.hypot(m.x - n.x, m.y - n.y) };
          })
          .filter(function (o) {
            return o.mi !== ni && o.d < 170 && o.d > 1;
          })
          .sort(function (a, b) {
            return a.d - b.d;
          })
          .slice(0, 2);
        near.forEach(function (o) {
          var key = Math.min(ni, o.mi) + '-' + Math.max(ni, o.mi);
          if (
            !edges.some(function (e) {
              return e.key === key;
            })
          ) {
            var e = { key: key, a: ni, b: o.mi, len: o.d, hot: 0, age: 1 };
            edges.push(e);
            nodes[ni].adj.push(e);
            nodes[o.mi].adj.push(e);
          }
        });
      });
      pulses = [];
      lastSpawn = 0;
      arrivals = 0;
    }

    function size() {
      w = window.innerWidth;
      h = window.innerHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      buildNetwork();
    }

    function onResize() {
      size();
      if (!raf) draw(performance.now());
    }

    size();
    tx = w / 2;
    ty = h / 3;
    cx = tx;
    cy = ty;

    function onMove(e) {
      tx = e.clientX;
      ty = e.clientY;
      var now = performance.now();
      if (now - lastMoveRipple > 650) {
        lastMoveRipple = now;
        ripples.push({ x: e.clientX, y: e.clientY, r: 4, max: 180, ww: 1 });
      }
      wakeLoop();
    }

    function onDown(e) {
      ripples.push({ x: e.clientX, y: e.clientY, r: 2, max: 280, ww: 1.6 });
      wakeLoop();
    }

    window.addEventListener('resize', onResize, { passive: true });

    function draw(now) {
      var dt = Math.min((now - last) / 1000, 0.05);
      last = now;
      var ctx = canvas.getContext('2d');
      if (!ctx || !grid) return;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, w, h);
      if (motion) {
        cx += (tx - cx) * 0.07;
        cy += (ty - cy) * 0.07;
      }
      var ox = motion ? (0.5 - cx / w) * 14 : 0;
      var oy = motion ? (0.5 - cy / h) * 14 : 0;
      ctx.save();
      ctx.translate(-26, -26);
      var pox = function (z) {
        return ox * (0.4 + z * 1.2);
      };
      var poy = function (z) {
        return oy * (0.4 + z * 1.2);
      };

      if (motion) {
        ripples.forEach(function (rp) {
          rp.r += 150 * dt * (1 - rp.r / (rp.max * 1.4));
        });
        ripples = ripples.filter(function (rp) {
          return rp.r < rp.max;
        });
      } else {
        ripples = [];
      }

      var P = grid.P;
      var cols = grid.cols;
      var rows = grid.rows;
      for (var i = 0; i < cols; i++) {
        for (var j = 0; j < rows; j++) {
          var z = zAt(i, j);
          var x = i * P + pox(z);
          var y = j * P + poy(z);
          var a = 0.035 + z * 0.075;
          for (var r = 0; r < ripples.length; r++) {
            var rp = ripples[r];
            var rx = rp.x + 26;
            var ry = rp.y + 26;
            if (Math.abs(x - rx) > rp.r + 20 || Math.abs(y - ry) > rp.r + 20) continue;
            var band = Math.abs(Math.hypot(x - rx, y - ry) - rp.r);
            if (band < 16) a += (0.15 + z * 0.3) * (1 - band / 16) * (1 - rp.r / rp.max);
          }
          var twSeed = zAt(i * 7 + 3, j * 13 + 9);
          var twSeed2 = zAt(i * 17 + 5, j * 23 + 11);
          var twPhase = twSeed * 6.283;
          var twSpeed = 0.25 + twSeed2 * 0.85;
          var twRaw = motion ? Math.sin(now * 0.001 * twSpeed + twPhase) : 0;
          var twinkle = Math.pow(Math.max(0, twRaw), 4);
          a += twinkle * (0.25 + z * 0.4);
          var colorRoll = zAt(i * 31 + 41, j * 19 + 53);
          var isColor = colorRoll < 0.045 && twinkle > 0.35;
          var rgb = isColor
            ? TWINKLE_COLORS[Math.floor((colorRoll / 0.045) * TWINKLE_COLORS.length) % TWINKLE_COLORS.length]
            : '255,255,255';
          var s = 1 + z * 1.2 + twinkle * 0.8;
          ctx.fillStyle = 'rgba(' + rgb + ',' + Math.min(a, 0.85).toFixed(3) + ')';
          ctx.fillRect(x - s / 2, y - s / 2, s, s);
        }
      }

      var N = nodes;
      var E = edges;
      var NX = function (n) {
        return n.x + pox(n.z);
      };
      var NY = function (n) {
        return n.y + poy(n.z);
      };
      for (var ei = 0; ei < E.length; ei++) {
        var e = E[ei];
        e.hot = Math.max(0, e.hot - dt * 1.4);
        e.age = Math.min(1, e.age + dt * 0.8);
        var zAvg = (N[e.a].z + N[e.b].z) / 2;
        ctx.strokeStyle = 'rgba(255,255,255,' + ((0.03 + zAvg * 0.045 + e.hot * 0.11) * e.age).toFixed(3) + ')';
        ctx.lineWidth = 0.7 + zAvg * 0.6;
        ctx.beginPath();
        ctx.moveTo(NX(N[e.a]), NY(N[e.a]));
        ctx.lineTo(NX(N[e.b]), NY(N[e.b]));
        ctx.stroke();
      }

      if (motion) {
        if (now - lastSpawn > 380 && pulses.length < 12 && E.length) {
          lastSpawn = now;
          var pe = E[Math.floor(Math.random() * E.length)];
          pulses.push({ e: pe, from: pe.a, t: 0, hops: 2 + Math.floor(Math.random() * 3) });
        }
        pulses = pulses.filter(function (p) {
          p.e.hot = Math.min(1, p.e.hot + dt * 3);
          p.t += (110 * dt) / p.e.len;
          if (p.t >= 1) {
            var arrive = p.e.a === p.from ? p.e.b : p.e.a;
            N[arrive].flash = 1;
            arrivals++;
            if (arrivals % 3 === 0 && E.length < 320) {
              var n = N[arrive];
              var cand = N.map(function (m, mi) {
                return { mi: mi, d: Math.hypot(m.x - n.x, m.y - n.y) };
              }).filter(function (o) {
                return (
                  o.d > 1 &&
                  o.d < 240 &&
                  !E.some(function (e2) {
                    return e2.key === Math.min(arrive, o.mi) + '-' + Math.max(arrive, o.mi);
                  })
                );
              });
              if (cand.length) {
                cand.sort(function (a2, b2) {
                  return a2.d - b2.d;
                });
                var pick = cand[Math.floor(Math.random() * Math.min(4, cand.length))];
                var ne = {
                  key: Math.min(arrive, pick.mi) + '-' + Math.max(arrive, pick.mi),
                  a: arrive,
                  b: pick.mi,
                  len: pick.d,
                  hot: 1,
                  age: 0,
                };
                E.push(ne);
                N[arrive].adj.push(ne);
                N[pick.mi].adj.push(ne);
              }
            }
            p.hops--;
            if (p.hops <= 0) return false;
            var options = N[arrive].adj.filter(function (e2) {
              return e2 !== p.e;
            });
            if (!options.length) return false;
            p.e = options[Math.floor(Math.random() * options.length)];
            p.from = arrive;
            p.t = 0;
          }
          var A = N[p.from];
          var B = p.e.a === p.from ? N[p.e.b] : N[p.e.a];
          var ax = NX(A);
          var ay = NY(A);
          var bx = NX(B);
          var by = NY(B);
          var px = ax + (bx - ax) * p.t;
          var py = ay + (by - ay) * p.t;
          ctx.fillStyle = 'rgba(255,255,255,0.14)';
          ctx.beginPath();
          ctx.arc(px, py, 4.5, 0, 6.29);
          ctx.fill();
          ctx.fillStyle = 'rgba(255,255,255,0.95)';
          ctx.beginPath();
          ctx.arc(px, py, 1.7, 0, 6.29);
          ctx.fill();
          return true;
        });
      }

      for (var ni = 0; ni < N.length; ni++) {
        var node = N[ni];
        if (node.flash > 0.02) {
          ctx.fillStyle = 'rgba(255,255,255,' + (0.5 * node.flash).toFixed(3) + ')';
          ctx.beginPath();
          ctx.arc(NX(node), NY(node), 2 + 3.5 * node.flash, 0, 6.29);
          ctx.fill();
          node.flash *= Math.pow(0.05, dt);
        }
      }

      for (var ri = 0; ri < ripples.length; ri++) {
        var rrp = ripples[ri];
        var fade = 1 - rrp.r / rrp.max;
        var rrx = rrp.x + 26;
        var rry = rrp.y + 26;
        ctx.lineWidth = rrp.ww;
        ctx.strokeStyle = 'rgba(255,255,255,' + (0.3 * fade).toFixed(3) + ')';
        ctx.beginPath();
        ctx.arc(rrx, rry, rrp.r, 0, 6.29);
        ctx.stroke();
        ctx.lineWidth = 1;
        ctx.strokeStyle = 'rgba(255,255,255,' + (0.12 * fade).toFixed(3) + ')';
        ctx.beginPath();
        ctx.arc(rrx, rry, rrp.r * 0.72, 0, 6.29);
        ctx.stroke();
      }
      ctx.restore();
    }

    function stopLoop() {
      if (raf) {
        cancelAnimationFrame(raf);
        raf = 0;
      }
    }

    function sleepLoop() {
      interactive = false;
      stopLoop();
      draw(performance.now());
    }

    function scheduleIdleStop() {
      window.clearTimeout(idleTimer);
      idleTimer = window.setTimeout(sleepLoop, IDLE_TIMEOUT_MS);
    }

    function wakeLoop() {
      if (!motion) return;
      interactive = true;
      scheduleIdleStop();
      startLoop();
    }

    function loop(now) {
      if (!motion || !interactive || document.hidden) {
        raf = 0;
        draw(now);
        return;
      }
      raf = requestAnimationFrame(loop);
      draw(now);
    }

    function startLoop() {
      if (!motion || !interactive || document.hidden || raf) return;
      last = performance.now();
      raf = requestAnimationFrame(loop);
    }

    if (motion) {
      window.addEventListener('pointermove', onMove, { passive: true });
      window.addEventListener('pointerdown', onDown, { passive: true });
      document.addEventListener('visibilitychange', function () {
        if (shimmer) shimmer.classList.toggle('is-paused', document.hidden);
        if (document.hidden) {
          stopLoop();
        } else {
          draw(performance.now());
          startLoop();
        }
      });
      if (shimmer) shimmer.classList.toggle('is-paused', document.hidden);
      draw(performance.now());
    } else {
      if (shimmer) shimmer.classList.add('is-paused');
      draw(performance.now());
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["motion-fx"] && !Shopify.designMode) return;
  try {
    (function () {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var nativeReveals =
      !reduced &&
      typeof CSS !== 'undefined' &&
      CSS.supports &&
      CSS.supports('(animation-timeline: view()) and (animation-range: entry)');

    function markReveals() {
      document
        .querySelectorAll('.zd-product-card, .zd-hero, .zd-email, .zd-section-header, .zd-footer')
        .forEach(function (el) {
          if (!el.classList.contains('zd-reveal')) el.classList.add('zd-reveal');
        });
    }

    function observeReveals() {
      markReveals();
      if (nativeReveals) return;

      var nodes = document.querySelectorAll('.zd-reveal');
      if (!nodes.length) return;

      if (reduced || !('IntersectionObserver' in window)) {
        nodes.forEach(function (el) {
          el.classList.add('is-visible');
        });
        return;
      }

      nodes.forEach(function (el) {
        el.classList.add('is-waiting');
      });

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );
      nodes.forEach(function (el) {
        io.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeReveals);
    } else {
      observeReveals();
    }

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function () {
        observeReveals();
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function initGallery(root) {
      if (root.dataset.zdGalleryReady === '1') return;
      root.dataset.zdGalleryReady = '1';

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-zd-gallery-slide]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-zd-gallery-thumb]'));
      var counter = root.querySelector('[data-zd-gallery-counter]');
      var prev = root.querySelector('[data-zd-gallery-prev]');
      var next = root.querySelector('[data-zd-gallery-next]');
      var total = slides.length;
      if (total < 2) return;

      var index = 0;

      function go(to) {
        index = ((to % total) + total) % total;
        slides.forEach(function (slide, i) {
          var on = i === index;
          slide.classList.toggle('is-active', on);
          if (on) slide.removeAttribute('hidden');
          else slide.setAttribute('hidden', '');
        });
        thumbs.forEach(function (thumb, i) {
          var on = i === index;
          thumb.classList.toggle('is-active', on);
          thumb.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        if (counter) {
          counter.textContent = '( ' + pad(index + 1) + ' / ' + pad(total) + ' )';
        }
      }

      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          go(Number(thumb.getAttribute('data-index')) || 0);
        });
      });

      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          go(index - 1);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          go(index + 1);
        }
      });

      var startX = 0;
      var viewport = root.querySelector('[data-zd-gallery-viewport]');
      if (viewport) {
        viewport.addEventListener('touchstart', function (e) {
          startX = e.changedTouches[0].clientX;
        }, { passive: true });
        viewport.addEventListener('touchend', function (e) {
          var dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) < 40) return;
          if (dx > 0) go(index - 1);
          else go(index + 1);
        }, { passive: true });
      }
    }

    document.querySelectorAll('[data-zd-gallery]').forEach(initGallery);
  })();
  } catch(e) { console.error(e); }
})();

})();
